<template>
  <div class="tryon-container">
    <div class="dialog-group">
      <glass-style-dialog class="menu-dialog" v-if="displayMenuDialogState.showGlassStyle" @select-item="selectOption" />
      <glass-texture-dialog class="menu-dialog" v-if="displayMenuDialogState.showGlassTexture" @select-item="selectOption" />
      <glass-temple-dialog class="menu-dialog" v-if="displayMenuDialogState.showGlassTemples" @select-item="selectOption" />
      <lens-color-dialog class="menu-dialog" v-if="displayMenuDialogState.showLensesColor" @select-item="selectOption" />
      <measurement-dialog class="menu-dialog" v-if="displayMenuDialogState.showMeasurement" @close="activeMenuDialog = null" />
    </div>
    <a-spin wrapperClassName="tryon-content-wrapper" :spinning="switching">
      <div ref="container" class="tryon-content" v-if="webcamOpened">
        <img v-if="fetching || !initDone" class="loading-logo" src="../../assets/images/go.png" alt="logo" />
        <canvas ref="customizer" id="glasson-canvas" class="glasson-canvas" key="1" />
        <video id="video" playsinline style="display: none" />
        <div class="edit-button">
          <go-button @try-on="doTryOn" :webcamOpened="webcamOpened" />
        </div>
      </div>
      <div ref="container" class="tryon-content" v-else>
        <img v-if="fetching || !initDone" class="loading-logo" src="../../assets/images/go.png" alt="logo" />
        <canvas ref="customizer" id="glasson-canvas" class="glasson-canvas" key="2" />
        <div class="edit-button">
          <go-button @try-on="doTryOn" :webcamOpened="webcamOpened" />
        </div>
        <a-button-group class="btn-group">
          <a-button shape="round" icon="minus" @click="zoomOut" />
          <a-button shape="round" icon="plus" @click="zoomIn" />
        </a-button-group>
      </div>
    </a-spin>
    <a-modal
      v-model="showTryOnModal"
      class="pd-modal"
      width="768px"
      height="auto"
      :footer="null"
      :destroy-on-close="true"
      :body-style="{ padding: 0 }"
    >
      <div class="pd-modal--container">
        <div class="pd-modal--content">
          <div class="pd-measure-view">
            <iframe
              width="100%"
              height="500"
              frameborder="0"
              allow="camera"
              allowfullscreen
              :src="'https://glasson.sk-global.biz/viewer?vto=1&orderId=' + orderId"
            />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { Modal } from "ant-design-vue";
import GlassTextureDialog from "../CustomizeMenu/GlassTextureDialog";
import GlassStyleDialog from "../CustomizeMenu/GlassStyleDialog";
import GlassTempleDialog from "../CustomizeMenu/GlassTempleDialog";
import LensColorDialog from "../CustomizeMenu/LensColorDialog";
import MeasurementDialog from "../CustomizeMenu/MeasurementDialog";
import GoButton from "./GoButton";
// import { createOrder } from "../../utils";

export default {
  components: {
    GlassStyleDialog,
    GlassTextureDialog,
    GlassTempleDialog,
    LensColorDialog,
    MeasurementDialog,
    GoButton
  },
  props: ["fetching"],
  data() {
    return {
      activeMenuDialog: null,
      initDone: false,
      switching: false,
      showTryOnModal: false,
      webcamOpened: false,
      glassesView: null
    };
  },
  computed: {
    displayMenuDialogState() {
      const key = this.activeMenuDialog;

      return {
        showGlassStyle: key === "glassStyle",
        showGlassTexture: key === "glassTexture",
        showGlassTemples: key === "glassTemples",
        showLensesColor: key === "lensesColor",
        showMeasurement: key === "measurement",
        none: key === null
      };
    },
    options() {
      return this.$store.state.options;
    },
    selectedOpt() {
      return this.$store.state.selectedOpt;
    },
    orderId() {
      return this.$store.state.orderId;
    }
  },
  mounted() {
    // const minDimension = Math.max(this.$refs.container.clientWidth, this.$refs.container.clientHeight);
    if (!this.fetching) {
      this.initPlugin();
    }

    this.$bus.$on("open-menu-dialog", key => {
      if (key) this.activeMenuDialog = key;
    });

    this.$bus.$on("close-menu-dialog", () => {
      this.activeMenuDialog = null;
    });

    window.addEventListener("resize", this.resizePluginArea);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizePluginArea);
  },
  watch: {
    fetching: function(val, oldVal) {
      if (!val && val !== oldVal) {
        this.initPlugin();
      }
    },
    selectedOpt: async function(val, oldVal) {
      if (this.initDone && val !== oldVal) {
        this.switching = true;
        if (val.style?.productId !== oldVal.style?.productId) {
          await this.switchOption(val.style);
        }
        await this.switchOption(val.rim);
        await this.switchOption(val.temple);
        await this.switchOption(val.lens);
        if (!this.webcamOpened) {
          this.glassesView.refresh();
        }
        this.switching = false;
      }
    }
  },
  methods: {
    initPlugin() {
      this.initDone = false;
      this.$refs.customizer.width = this.$refs.container.clientWidth;
      this.$refs.customizer.height = this.$refs.container.clientHeight;
      this.$refs.customizer.addEventListener("touchmove", e => e.preventDefault());

      // Do not comment out below
      if (this.webcamOpened) {
        // eslint-disable-next-line no-undef
        this.glassesView = new TryOnView("glasson-canvas");
      } else {
        // eslint-disable-next-line no-undef
        this.glassesView = new GlassesView("glasson-canvas");
      }

      // eslint-disable-next-line no-undef
      this.glassesView.start().then(
        async () => {
          await this.switchOption(this.selectedOpt.style);
          await this.switchOption(this.selectedOpt.rim);
          await this.switchOption(this.selectedOpt.temple);
          await this.switchOption(this.selectedOpt.lens);

          if (!this.webcamOpened) {
            for (let i = 0; i < 1; ++i) {
              this.glassesView.zoomOut();
            }
          }
          this.initDone = true;
        },
        err => {
          console.error(err);
          Modal.error({ title: "Exception", content: err.message });
        }
      );
    },
    resizePluginArea() {
      if (this.glassesView) {
        // const { clientWidth, clientHeight } = this.$refs.container;
        if (this.webcamOpened) {
          // this.glassesView.resizeView(clientWidth, clientHeight);
        } else {
          // const minDimension = Math.max(clientWidth, clientHeight);
          // this.glassesView.resizeView(clientWidth, clientHeight);
        }
      }
    },
    zoomIn() {
      if (!this.webcamOpened) {
        this.glassesView.zoomIn();
      }
    },
    zoomOut() {
      if (!this.webcamOpened) {
        this.glassesView.zoomOut();
      }
    },
    snapshot() {
      return this.glassesView.snapshot();
    },
    selectOption(item) {
      this.activeMenuDialog = null;
      this.$bus.$emit("select-option");
      this.$store.commit("selectOption", item);
    },
    async doTryOn() {
      try {
        // this.switching = true;
        // const order = await createOrder(this.selectedOpt, this.$store.state.pd, null, this.orderId);
        // this.$store.commit("updateOrderId", order.id);
        // this.showTryOnModal = true;
        // this.switching = false;
        if (!this.initDone) {
          return;
        }
        if (this.webcamOpened) {
          // eslint-disable-next-line no-undef
          // JEEFACEFILTERAPI.destroy();
        }
        this.glassesView.stop();
        this.webcamOpened = !this.webcamOpened;
        Vue.nextTick(() => {
          try {
            this.initPlugin(this.webcamOpened);
          } catch (err) {
            console.error(err);
            Modal.error({ title: "Exception", content: err.message });
          }
        });
      } catch (err) {
        console.error(err);
        Modal.error({ title: "Exception", content: err.message });
      }
    },
    switchOption(option) {
      switch (option.kind) {
        case "style":
          return this.tryGlasses(option.model);
        case "rim":
        case "temple": {
          return new Promise(resolve => {
            // eslint-disable-next-line no-undef
            Utility.loadTextureAsync(option.texture || "assets/white_texture.png").then(texture => {
              const colors = option.colors?.split("|");
              const tRgba = colors?.[0]?.split(",");
              const bRgba = colors?.[1]?.split(",");
              const parts =
                option.kind === "rim"
                  ? // eslint-disable-next-line no-undef
                    [Glss25DPart.WIRES]
                  : // eslint-disable-next-line no-undef
                    [Glss25DPart.L_TEMPLES, Glss25DPart.R_TEMPLES];
              parts.forEach(part => {
                this.glassesView.currentGlasses.setFilter(part, {
                  texture,
                  ...(tRgba
                    ? {
                        // eslint-disable-next-line no-undef
                        topColor: new THREE.Vector4(+tRgba[0] / 255, +tRgba[1] / 255, +tRgba[2] / 255, +tRgba[3]),
                        // eslint-disable-next-line no-undef
                        bottomColor: new THREE.Vector4(+tRgba[0] / 255, +tRgba[1] / 255, +tRgba[2] / 255, +tRgba[3])
                      }
                    : {
                        // eslint-disable-next-line no-undef
                        topColor: new THREE.Vector4(1, 1, 1, 1),
                        // eslint-disable-next-line no-undef
                        bottomColor: new THREE.Vector4(1, 1, 1, 1)
                      }),
                  ...(bRgba && {
                    // eslint-disable-next-line no-undef
                    bottomColor: new THREE.Vector4(+bRgba[0] / 255, +bRgba[1] / 255, +bRgba[2] / 255, +bRgba[3])
                  })
                });
              });
              resolve();
            });
          });
        }
        case "lens": {
          return new Promise(resolve => {
            if (option.texture) {
              // eslint-disable-next-line no-undef
              Utility.loadTextureAsync(option.texture).then(texture => {
                this.glassesView.currentGlasses.setLensesFilter({
                  tex: texture,
                  // eslint-disable-next-line no-undef
                  color: new THREE.Vector4(1, 1, 1, 0.66),
                  reflection: option.reflection || 0.5
                });
                resolve();
              });
            } else {
              // eslint-disable-next-line no-undef
              Utility.loadTextureAsync("assets/white_texture.png").then(texture => {
                const rgba = option.colors.split(",");
                this.glassesView.currentGlasses.setLensesFilter({
                  tex: texture,
                  // eslint-disable-next-line no-undef
                  color: new THREE.Vector4(+rgba[0] / 255, +rgba[1] / 255, +rgba[2] / 255, rgba[3] ? +rgba[3] : 1),
                  reflection: rgba[3] ? 0.5 : 0.75
                });
                resolve();
              });
            }
          });
        }
        default:
          break;
      }
    },
    tryGlasses(s3Key) {
      return new Promise(resolve => {
        const zipUrl = window.GLASSON_CONFIG.STORAGE + s3Key;
        // eslint-disable-next-line no-undef
        this.glassesView.tryGlasses(zipUrl, GlassesTypeEnum.GLSS_25D).then(
          () => resolve(),
          err => Modal.error({ title: "Exception", content: err.message })
        );
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@keyframes backInUp {
  0% {
    transform: translateY(1200px) scale(0.7);
    opacity: 0.7;
  }

  80% {
    transform: translateY(0px) scale(0.7);
    opacity: 0.7;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.backInUp {
  animation-name: backInUp;
}

.tryon {
  &-container {
    position: relative;
    height: 100%;

    .menu-dialog {
      position: absolute;
      bottom: -10px;
      left: 0px;
      z-index: 999;
      animation-name: backInUp;
      animation-duration: 0.5s;
    }
  }

  &-header {
    color: red;
  }

  &-content-wrapper {
    height: 100%;
  }

  &-content {
    width: 100%;
    height: 100%;
    // background-color: rgba(225, 225, 225);
    // border: 4px solid #f9d802;
    box-sizing: border-box;
    // border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;

    .loading-logo {
      width: 30%;
      height: auto;
      animation-name: blinker;
      animation-duration: 0.6s;
      animation-iteration-count: infinite;
      animation-timing-function: ease-in-out;
      animation-direction: alternate;
      position: absolute;
      z-index: 10;
    }

    .glasson-canvas {
      position: absolute;
      top: 50%;
      left: 50%;
      right: 0;
      bottom: 0;
      transform: translate(-50%, -50%);
    }

    .edit-button {
      position: absolute;
      top: 24px;
      left: 24px;
      z-index: 10;
    }

    .btn-group {
      position: absolute;
      left: 24px;
      bottom: 24px;
    }

    @keyframes blinker {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
  }
}

.pd-modal {
  &--container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &--content {
    width: 100%;
    padding: 0px;

    .pd-measure-view {
      height: 500px;
      border: 6px solid #f9d802;
      border-radius: 32px;
      position: relative;
      overflow: hidden;
    }
  }
}
</style>
